import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const City = ({ required }) => {
  const { t } = useTranslation();
  return (
    <Form.Item name="city" label={t("billing.cityLabel")} rules={[{ required: required, message: t("billing.cityRequired") }]} hasFeedback>
      <Input placeholder={t("billing.cityPlaceholder")} />
    </Form.Item>
  );
};

export default City;
